import { action } from 'easy-peasy';
import { mergeUniqueBy } from '~/utils/pagination';
import { IActionSetMoreIcd10Codes } from '../types';

const setMoreIcd10Codes: IActionSetMoreIcd10Codes = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.length;
  const newItems = mergeUniqueBy(state.items, payload, item => item.id);

  state.items = [...newItems];
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setMoreIcd10Codes;
